import type { DataModelView } from '../../api/dataModelsService';
import type { PhysicalTable } from './types';

/**
 * Resolve all physical table IDs used by a semantic view.
 * For multi-fact views, recursively resolves child fact views.
 */
export function getPhysicalTablesForView(
  view: DataModelView,
  allViews: DataModelView[],
  physicalTables: PhysicalTable[]
): Set<string> {
  const tableIds = new Set<string>();

  const resolveBaseTables = (baseTables: string[], depth = 0) => {
    if (depth > 5) return; // prevent infinite recursion
    for (const name of baseTables) {
      // Try matching physical table first (case-insensitive)
      const pt = physicalTables.find(
        (t) =>
          t.name.toLowerCase() === name.toLowerCase() ||
          (t.aliasName && t.aliasName.toLowerCase() === name.toLowerCase())
      );
      if (pt) {
        tableIds.add(pt.id);
      } else {
        // Could be a reference to another view (multi-fact case)
        const childView = allViews.find(
          (v) => v.name.toLowerCase() === name.toLowerCase()
        );
        if (childView) {
          resolveBaseTables(childView.baseTables, depth + 1);
        }
      }
    }
  };

  resolveBaseTables(view.baseTables);
  return tableIds;
}